import React from 'react';
import { WebLayout } from 'components/Layout';
import { motion } from 'framer-motion';
import HeaderBackgroundImg from 'assets/workshop.png';
import { Calendar, Phone, MapPin, Clock } from 'react-feather';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

export function BookAnAppointment() {
  return (
    <WebLayout>
      {/* ===== Hero Section ===== */}
      <section
        className="relative h-[60vh] flex items-center justify-center bg-center bg-cover text-white"
        style={{ backgroundImage: `url(${HeaderBackgroundImg})` }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <motion.div
          className="relative z-10 text-center px-4"
          variants={fadeUp}
          initial="hidden"
          animate="visible"
        >
          <h1 className="text-3xl sm:text-6xl font-semibold mb-3 just-me-again-down-here-regular">
            Book an Appointment
          </h1>
          <p className="text-sm sm:text-base max-w-xl mx-auto text-gray-200">
            Every masterpiece begins with a conversation — meet our craftsmen, explore materials,
            and co-create designs that tell your story.
          </p>
        </motion.div>
      </section>

      {/* ===== Booking Form Section ===== */}
      <section className="bg-[#FFF6F2] py-20 px-6 sm:px-12 lg:px-24">
        <motion.div
          className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16"
          variants={fadeUp}
          initial="hidden"
          animate="visible"
        >
          {/* --- Left: Form --- */}
          <div className="bg-white shadow-md rounded-lg p-8">
            <h2 className="text-2xl font-semibold text-[#AC3F1E] mb-6">Schedule Your Visit</h2>
            <form className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                <input
                  type="text"
                  placeholder="John Doe"
                  className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    placeholder="you@example.com"
                    className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    placeholder="+256 700 000 000"
                    className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Preferred Date
                  </label>
                  <input
                    type="date"
                    className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Preferred Time
                  </label>
                  <input
                    type="time"
                    className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Purpose of Appointment
                </label>
                <select className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]">
                  <option value="">Select...</option>
                  <option>Custom Furniture Consultation</option>
                  <option>Product Viewing</option>
                  <option>Collaboration Inquiry</option>
                  <option>Other</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Additional Notes
                </label>
                <textarea
                  rows="4"
                  placeholder="Tell us more..."
                  className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-[#AC3F1E] text-white uppercase tracking-wide py-3 font-semibold rounded-md hover:opacity-90 transition"
              >
                Book Appointment
              </button>
            </form>
          </div>

          {/* --- Right: Info + Map --- */}
          <div className="flex flex-col justify-between space-y-8">
            <div className="bg-white shadow-md rounded-lg p-8">
              <h2 className="text-2xl font-semibold text-[#AC3F1E] mb-6">Visit Our Workshop</h2>

              <div className="space-y-6 text-gray-700 text-sm">
                <div className="flex items-start gap-3">
                  <MapPin className="text-[#AC3F1E] mt-1" size={18} />
                  <p>
                    Ayinza Qreatives Workshop
                    <br />
                    Plot 45, Kyanja, Kampala, Uganda
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <Phone className="text-[#AC3F1E] mt-1" size={18} />
                  <p>
                    +256 775 543 827 <br />
                    +256 743 891 517
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <Clock className="text-[#AC3F1E] mt-1" size={18} />
                  <p>
                    Mon – Fri: 9:00am – 5:30pm <br />
                    Sat: 9:00am – 2:00pm
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <Calendar className="text-[#AC3F1E] mt-1" size={18} />
                  <p>
                    Bookings are free. Appointments usually last
                    <br /> 30–45 minutes depending on discussion depth.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </section>
    </WebLayout>
  );
}
